import { AGING_COLORS_BY_ID, LEGACY_AGING_LABELS } from './dealershipSettings';

// A price prediction is only "real" if it's a positive number. The price model
// clips negative/out-of-distribution predictions to exactly 0, so treat 0 (and
// null/NaN) as "no prediction" everywhere it's displayed or compared.
export const validPrice = (value) =>
    (typeof value === 'number' && value > 0 && !Number.isNaN(value) ? value : null);

export const formatCurrency = (value) => {
    if (value === null || value === undefined || Number.isNaN(value)) return '-';
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(value);
};

export const formatNumber = (value) => {
    if (value === null || value === undefined || Number.isNaN(value)) return '-';
    return new Intl.NumberFormat('en-US').format(value);
};

export const formatDate = (value) => {
    if (!value) return '-';
    return new Date(value).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });
};

// Today's colour per aging bucket id (1–4); a legacy label still works.
export const getDaysInStockColor = (bucket) => (
    AGING_COLORS_BY_ID[typeof bucket === 'number' ? bucket : LEGACY_AGING_LABELS[bucket]] || '#718096'
);

export const getPredictedBucketStyle = (bucket) => {
    if (!bucket) return { bg: '#f1f5f9', text: '#94a3b8', border: '#cbd5e1', label: 'N/A' };
    const normalized = bucket.toLowerCase();
    if (normalized.includes('quick')) return { bg: '#dcfce7', text: '#15803d', border: '#86efac', label: 'Quick Sell' };
    if (normalized.includes('normal')) return { bg: '#dbeafe', text: '#1d4ed8', border: '#93c5fd', label: 'Normal' };
    if (normalized.includes('slow')) return { bg: '#fef3c7', text: '#b45309', border: '#fcd34d', label: 'Slow' };
    if (normalized.includes('critical')) return { bg: '#fee2e2', text: '#b91c1c', border: '#fca5a5', label: 'Critical' };
    return { bg: '#f1f5f9', text: '#94a3b8', border: '#cbd5e1', label: bucket };
};

export const getBuyerHeatStyle = (quoteCount, daysSince) => {
    if (!quoteCount || daysSince == null) return { label: 'No Interest', color: '#94a3b8', bg: '#f1f5f9' };
    if (daysSince <= 7) return { label: 'Hot', color: '#b91c1c', bg: '#fee2e2' };
    if (daysSince <= 30) return { label: 'Warm', color: '#b45309', bg: '#fef3c7' };
    if (daysSince <= 90) return { label: 'Cold', color: '#1d4ed8', bg: '#dbeafe' };
    return { label: 'No Interest', color: '#94a3b8', bg: '#f1f5f9' };
};


/**
 * Display text for an anomaly verdict. The backend's verdict strings are
 * stable API keys (colors and filters match on them exactly), so the "AI"
 * wording is softened at render time only — never in the keys.
 */
export function verdictLabel(verdict) {
    return verdict ? verdict.replace(/\bAI Estimate\b/g, 'Estimate') : verdict;
}
